"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MW = void 0;
exports.MW = {
    numericCode: '454',
    alpha2Code: 'MW',
    alpha3Code: 'MWI',
    englishName: {
        short: 'Malawi',
        full: 'the Republic of Malawi',
    },
    names: {
        full: {
            en: 'the Republic of Malawi',
            fr: 'la République du Malawi',
            ny: 'Malaŵi',
        },
        short: {
            en: 'Malawi',
            fr: 'Malawi (le)',
            ny: 'Malaŵi',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'ny',
            languageAlpha3Code: 'nya',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'MW-C': {
            numericCode: '454',
            code: 'MW-C',
            category: {
                id: '135',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ny: {
                        singular: 'mchigawo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Central Region',
                ny: 'Chapakati',
            },
        },
        'MW-DE': {
            numericCode: '454',
            code: 'MW-DE',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Dedza',
                ny: 'Dedza',
            },
        },
        'MW-DO': {
            numericCode: '454',
            code: 'MW-DO',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Dowa',
                ny: 'Dowa',
            },
        },
        'MW-KS': {
            numericCode: '454',
            code: 'MW-KS',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Kasungu',
                ny: 'Kasungu',
            },
        },
        'MW-LI': {
            numericCode: '454',
            code: 'MW-LI',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Lilongwe',
                ny: 'Lilongwe',
            },
        },
        'MW-MC': {
            numericCode: '454',
            code: 'MW-MC',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Mchinji',
                ny: 'Mchinji',
            },
        },
        'MW-NI': {
            numericCode: '454',
            code: 'MW-NI',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Ntchisi',
                ny: 'Ntchisi',
            },
        },
        'MW-NK': {
            numericCode: '454',
            code: 'MW-NK',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Nkhotakota',
                ny: 'Nkhotakota',
            },
        },
        'MW-NU': {
            numericCode: '454',
            code: 'MW-NU',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Ntcheu',
                ny: 'Ntcheu',
            },
        },
        'MW-SA': {
            numericCode: '454',
            code: 'MW-SA',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-C',
            names: {
                en: 'Salima',
                ny: 'Salima',
            },
        },
        'MW-N': {
            numericCode: '454',
            code: 'MW-N',
            category: {
                id: '135',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ny: {
                        singular: 'mchigawo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Northern Region',
                ny: 'Chakumpoto',
            },
        },
        'MW-CT': {
            numericCode: '454',
            code: 'MW-CT',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-N',
            names: {
                en: 'Chitipa',
                ny: 'Chitipa',
            },
        },
        'MW-KR': {
            numericCode: '454',
            code: 'MW-KR',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-N',
            names: {
                en: 'Karonga',
                ny: 'Karonga',
            },
        },
        'MW-LK': {
            numericCode: '454',
            code: 'MW-LK',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-N',
            names: {
                en: 'Likoma',
                ny: 'Likoma',
            },
        },
        'MW-MZ': {
            numericCode: '454',
            code: 'MW-MZ',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-N',
            names: {
                en: 'Mzimba',
                ny: 'Mzimba',
            },
        },
        'MW-NB': {
            numericCode: '454',
            code: 'MW-NB',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-N',
            names: {
                en: 'Nkhata Bay',
                ny: 'Nkhata Bay',
            },
        },
        'MW-RU': {
            numericCode: '454',
            code: 'MW-RU',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-N',
            names: {
                en: 'Rumphi',
                ny: 'Rumphi',
            },
        },
        'MW-S': {
            numericCode: '454',
            code: 'MW-S',
            category: {
                id: '135',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ny: {
                        singular: 'mchigawo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Southern Region',
                ny: 'Chakumwera',
            },
        },
        'MW-BA': {
            numericCode: '454',
            code: 'MW-BA',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Balaka',
                ny: 'Balaka',
            },
        },
        'MW-BL': {
            numericCode: '454',
            code: 'MW-BL',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Blantyre',
                ny: 'Blantyre',
            },
        },
        'MW-CK': {
            numericCode: '454',
            code: 'MW-CK',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Chikwawa',
                ny: 'Chikwawa',
            },
        },
        'MW-CR': {
            numericCode: '454',
            code: 'MW-CR',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Chiradzulu',
                ny: 'Chiradzulu',
            },
        },
        'MW-MG': {
            numericCode: '454',
            code: 'MW-MG',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Mangochi',
                ny: 'Mangochi',
            },
        },
        'MW-MH': {
            numericCode: '454',
            code: 'MW-MH',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Machinga',
                ny: 'Machinga',
            },
        },
        'MW-MU': {
            numericCode: '454',
            code: 'MW-MU',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Mulanje',
                ny: 'Mulanje',
            },
        },
        'MW-MW': {
            numericCode: '454',
            code: 'MW-MW',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Mwanza',
                ny: 'Mwanza',
            },
        },
        'MW-NE': {
            numericCode: '454',
            code: 'MW-NE',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Neno',
                ny: 'Neno',
            },
        },
        'MW-NS': {
            numericCode: '454',
            code: 'MW-NS',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Nsanje',
                ny: 'Nsanje',
            },
        },
        'MW-PH': {
            numericCode: '454',
            code: 'MW-PH',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Phalombe',
                ny: 'Phalombe',
            },
        },
        'MW-TH': {
            numericCode: '454',
            code: 'MW-TH',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Thyolo',
                ny: 'Thyolo',
            },
        },
        'MW-ZO': {
            numericCode: '454',
            code: 'MW-ZO',
            category: {
                id: '367',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    ny: {
                        singular: 'boma',
                        plural: '',
                    },
                },
            },
            parent: 'MW-S',
            names: {
                en: 'Zomba',
                ny: 'Zomba',
            },
        },
    },
    cities: [
        {
            name: 'Karonga',
            subdivision: 'Northern Region',
        },
        {
            name: 'Zomba',
            subdivision: 'Southern Region',
        },
        {
            name: 'Salima',
            subdivision: 'Central Region',
        },
        {
            name: 'Rumphi',
            subdivision: 'Northern Region',
        },
        {
            name: 'Nsanje',
            subdivision: 'Southern Region',
        },
        {
            name: 'Nkhotakota',
            subdivision: 'Central Region',
        },
        {
            name: 'Mzuzu',
            subdivision: 'Northern Region',
        },
        {
            name: 'Mzimba',
            subdivision: 'Northern Region',
        },
        {
            name: 'Mulanje',
            subdivision: 'Southern Region',
        },
        {
            name: 'Mchinji',
            subdivision: 'Central Region',
        },
        {
            name: 'Mangochi',
            subdivision: 'Southern Region',
        },
        {
            name: 'Liwonde',
            subdivision: 'Southern Region',
        },
        {
            name: 'Lilongwe',
            subdivision: 'Central Region',
        },
        {
            name: 'Kasungu',
            subdivision: 'Central Region',
        },
        {
            name: 'Dedza',
            subdivision: 'Central Region',
        },
        {
            name: 'Blantyre',
            subdivision: 'Southern Region',
        },
        {
            name: 'Balaka',
            subdivision: 'Southern Region',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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